<div class="c-toaster">
  @for (toast of toasts$ | async; track toast.id) {
    <app-custom-toast-item [toast]="toast"></app-custom-toast-item>
  }
</div>
